export default __webpack_public_path__ + "static/media/bearer-logo-footer.783a4473.svg";